export default __webpack_public_path__ + "static/easy_type_label-125e95b8d76206d0e900b83a79cc29dc.svg";